import styled from 'styled-components';

import { CARET_LEFT, CARET_RIGHT, CARET_UP } from '@/constants';

const getRotation = (direction) => {
  switch (direction) {
    case CARET_UP:
      return '180deg';
    case CARET_RIGHT:
      return '-90deg';
    case CARET_LEFT:
      return '90deg';
    default:
      return '0deg';
  }
};

export const IconStyled = styled.svg`
  transform: rotate(${({ $direction }) => getRotation($direction)});
`;

export default IconStyled;
